<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-card>
                <v-form ref="entryForm">
                    <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                        <v-flex lg12 pa-0 pr-6 pt-6 v-if="!isCheckdon">
                            <v-layout row wrap justify-end>
                                <v-btn
                                    v-if="(adminRole || paymentRole) && currentItem.ID > 0 && currentItem.Details.length > 0"
                                    @click="paymentAndExport" color="red" dark>
                                    Thanh toán & xuất kho
                                </v-btn>
                                <v-btn
                                    v-if="currentItem.ID > 0 && (adminRole || (currentItem.Status != request_status_enum.hoan_thanh && !paymentRole))"
                                    @click="saveData(null)" dark class="ml-2">
                                    Lưu lại
                                </v-btn>
                                <v-btn v-if="!currentItem.ID" @click="saveData(request_status_enum.nhap)" dark
                                    class="ml-2">
                                    Lưu nháp
                                </v-btn>
                                <v-btn v-if="!currentItem.ID || currentItem.Status == request_status_enum.nhap"
                                    @click="saveData(request_status_enum.chua_xu_ly)" class="ml-2">
                                    Gửi yêu cầu
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-select label="Trạng thái" :items="request_status" v-model="currentItem.Status"
                                item-text="name" item-value="value" readonly></v-select>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-autocomplete label="Nhân viên kho" v-model="currentItem.StoreUID" :items="staffs"
                                item-text="Username" item-value="ID" @change="onSelectStaff"
                                :readonly="isCheckdon"
                                :rules="requireRules"></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-autocomplete label="Hình thức vận chuyển" v-model="currentItem.ShippingType"
                                :items="shippingTypes" item-text="name" item-value="value"
                                :readonly="isCheckdon"
                                @change="onChangeShippingType"></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-autocomplete label="Khách hàng" v-model="currentItem.UID" :items="customers"
                                item-text="Username" item-value="ID" @change="onSelectCustomer" :rules="requireRules"
                                :readonly="isCheckdon || (currentItem.Details && currentItem.Details.length > 0) || ((saleRole || csRole) && currentItem.Status != request_status_enum.nhap)"></v-autocomplete>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-text-field v-model="currentItem.ReceiverPhone" label="Điện thoại"
                                class="input-group--focused" :rules="requireRules"
                                :readonly="isCheckdon || ((saleRole || csRole) && currentItem.Status != request_status_enum.nhap)"></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-select label="Người trả ship" :items="fee_ship_types" v-model="currentItem.IsFreeShip"
                                item-text="name" item-value="value"
                                :disabled="isCheckdon || (currentItem.ID > 0 && !adminRole && (currentItem.Status == request_status_enum.hoan_thanh || (!paymentRole && currentItem.CreatedBy != currentUser)))"></v-select>
                        </v-flex>
                        <v-flex lg4 md4 sm12 xs12>
                            <v-select label="Kế toán" :items="accountants" v-model="currentItem.AccountantID"
                                item-text="name" item-value="value" :disabled="isCheckdon || !(adminRole || saleRole)"></v-select>
                        </v-flex>
                        <v-flex lg8 md8 sm12 xs12>
                            <v-text-field v-model="currentItem.ReceiverAddress" label="Địa chỉ nhận"
                                class="input-group--focused" :rules="requireRules"
                                :readonly="isCheckdon || ((saleRole || csRole) && currentItem.Status != request_status_enum.nhap)"></v-text-field>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-textarea v-model="currentItem.Note" label="Ghi chú"
                                :readonly="isCheckdon"
                                class="input-group--focused"></v-textarea>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12 v-if="!isCheckdon">
                            <v-layout row wrap justify-end pr-1>
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-2" dark color="red" v-bind="attrs" v-on="on"
                                            :disabled="currentItem.Status != request_status_enum.nhap || paymentRole || ((saleRole || csRole) && currentItem.Status != request_status_enum.nhap)">Thêm
                                            mới<v-icon medium class="ml-2 mb-2">fa-sort-desc</v-icon></v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item @click="addDetailItem">
                                            <v-list-item-title>Đơn hàng</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="addPackageItem">
                                            <v-list-item-title>Kiện TMĐT</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-layout>
                        </v-flex>
                        <v-flex lg12>
                            <v-card>
                                <v-data-table :headers="headers" :items="currentItem.Details" disable-pagination
                                    hide-default-footer :loading="loading">
                                    <template v-slot:item="{ item }">
                                        <tr v-if="item.OrderType != 3">
                                            <td><a target="_blank"
                                                    :href="(item.OrderType == 1 ? '/don-hang/' : '/ky-gui/ky-gui-lo/') + item.OrderID">
                                                    {{ item.OrderID ? (item.OrderType == 1 ? 'MD' : 'KG') + item.OrderID
                                                        : '' }}</a></td>
                                            <td class="text-end font-weight-bold">{{ item.TotalWeight | currency('',
                                                1) }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalAmount | currency }}</td>
                                            <td
                                                v-bind:style="{ 'color': get_status_color(item.Status, order_status), 'caret-color': get_status_color(item.Status, order_status) }">
                                                {{ item.Status | display_value(order_status) }}</td>
                                            <td>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                                            <td>{{ item.ReceivePlaceID | display_value(warehouses, 'ID', 'Name') }}</td>
                                            <td class="text-center"><v-icon v-if="!isCheckdon" medium @click="deleteDetailItem(item.ID)"
                                                    :disabled="currentItem.Status != request_status_enum.nhap || paymentRole">delete</v-icon>
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td>{{ item.TransactionCode }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalWeight | currency('',
                                                1) }}</td>
                                            <td class="text-end font-weight-bold">{{ item.FeeWeight | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.FeeWeightAmount | currency }}
                                            </td>
                                            <td class="text-end font-weight-bold">{{ item.FeeShip | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.GuaranteeAmountVND | currency
                                            }}</td>
                                            <td class="text-end font-weight-bold">{{ item.CheckFeeVND | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.FragileFeeVND | currency }}
                                            </td>
                                            <td class="text-end font-weight-bold">{{ item.FoamFeeVND | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.FeeShipVN | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.FeeOther | currency }}</td>
                                            <td>{{ item.FeeOtherNote }}</td>
                                            <td>{{ item.StoreCNNote }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalAmount | currency }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalPaidAmount | currency }}
                                            </td>
                                            <td class="text-end font-weight-bold">{{ item.TotalRemainAmount | currency
                                                }}
                                            </td>
                                            <td
                                                v-bind:style="{ 'color': get_status_color(item.Status, package_status), 'caret-color': get_status_color(item.Status, package_status) }">
                                                {{ item.Status | display_value(package_status) }}</td>
                                            <td>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                                            <td>{{ item.ReceivePlaceID | display_value(warehouses, 'ID', 'Name') }}</td>
                                            <td class="text-center"><v-icon v-if="!isCheckdon" medium @click="deleteDetailItem(item.ID)"
                                                    :disabled="currentItem.Status != request_status_enum.nhap || paymentRole">delete</v-icon>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card>
        </v-container>
        <v-dialog v-model="dialogItem" max-width="1200px">
            <v-card>
                <v-card-title>
                    <h5 class="title">Danh sách đơn hàng</h5>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogItem = false">Exit</v-btn>
                    <v-btn color="blue darken-1 white--text" class="mr-2" @click="onSelectDetail">Save</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg12>
                                <v-data-table fixed-header height="450px" :headers="headers" :items="popup_items"
                                    item-key="OrderID" disable-pagination hide-default-footer show-select
                                    v-model="selectedDetail">
                                    <template v-slot:item="{ item, isSelected, select }">
                                        <tr :active="isSelected"
                                            @click="!(item.IsPackNotMatch || item.MissingPackage) ? select(!isSelected) : isSelected"
                                            :class="{ 'disabled-row': item.IsPackNotMatch || item.MissingPackage }">
                                            <td><v-checkbox primary hide-details :input-value="isSelected"
                                                    v-if="!(item.IsPackNotMatch || item.MissingPackage)"></v-checkbox>
                                            </td>
                                            <td><a target="_blank"
                                                    :href="(item.OrderType == 1 ? '/don-hang/' : '/ky-gui/ky-gui-lo/') + item.OrderID">
                                                    {{ item.OrderID ? (item.OrderType == 1 ? 'MD' : 'KG') + item.OrderID
                                                        : '' }}</a></td>
                                            <td class="text-end font-weight-bold">{{ item.TotalWeight | currency('',
                                                1) }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalAmount | currency }}</td>
                                            <td>{{ item.Status | display_value(order_status) }}</td>
                                            <td>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                                            <td>{{ item.ReceivePlaceID | display_value(warehouses, 'ID', 'Name') }}</td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogPackageItem" max-width="1200px">
            <v-card>
                <v-card-title>
                    <h5 class="title">Danh sách kiện hàng TMĐT</h5>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogPackageItem = false">Exit</v-btn>
                    <v-btn color="blue darken-1 white--text" class="mr-2" @click="onSelectDetail">Save</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-layout row wrap>
                            <v-flex lg12>
                                <v-data-table fixed-header height="450px" :headers="package_headers"
                                    :items="popup_package_items" item-key="ID" disable-pagination hide-default-footer
                                    show-select v-model="selectedDetail">
                                    <template v-slot:item="{ item, isSelected, select }">
                                        <tr :active="isSelected" @click="select(!isSelected)">
                                            <td><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                                            </td>
                                            <td>{{ item.TransactionCode }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalWeight | currency('',
                                                1) }}</td>
                                            <td class="text-end font-weight-bold">{{ item.TotalAmount | currency }}</td>
                                            <td>{{ item.Status | display_value(package_status) }}</td>
                                            <td>{{ item.ChinaStoreID | display_value(chinaStores, 'ID', 'Name') }}</td>
                                            <td>{{ item.ReceivePlaceID | display_value(warehouses, 'ID', 'Name') }}</td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
export default {
    data() {
        return {
            valid: true,
            requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
            package_headers: [
                {
                    text: "Mã vận đơn",
                    value: "TransactionCode",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân",
                    value: "Weight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.ORDER_STATUS
                },
                {
                    text: "Kho gửi",
                    value: "ChinaStoreID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: []
                },
                {
                    text: "Kho nhận",
                    value: "ReceivePlaceID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: []
                },
                {
                    text: ""
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["ID"] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            request_status: configs.PAYMENT_REQUEST_STATUS,
            request_status_enum: configs.PAYMENT_REQUEST_STATUS_ENUM,
            order_status: configs.ORDER_STATUS,
            package_status: configs.PACKAGE_STATUS,
            fee_ship_types: configs.FEE_SHIP_TYPES,
            popupViewName: "popup_detail",
            selectedDetail: [],
            dialogItem: false,
            filterConditions: [],
            quickFilterConditions: [],
            dialogPackageItem: false,
        };
    },
    computed: {
        ...mapState({
            loading: state => state.paymentRequest.loading,
            currentItem: state => state.paymentRequest.selected,
            all_customers: state => state.customer.master.data,
            warehouses: (state) => state.commons.stores,
            chinaStores: (state) => state.commons.chinaStores,
            staffs: (state) => _.filter(state.commons.all_users, function (o) { return ((o.RoleType & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN) && o.is_active; }),
            popup_items: state => state.paymentRequest.orders.data,
            popup_package_items: state => state.paymentRequest.packages.data,
            configuration: state => state.configuration.selected,
            accountants: (state) => _.map(_.filter(state.commons.all_users, function (o) {
                return (o.RoleType & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment && o.is_active == 1;
            }), p => { return { 'value': p.ID, 'name': p.Username } })
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        currentUserID() {
            return this.$store.state.authentication.user.userid;
        },
        currentUser() {
            return this.$store.state.authentication.user.username;
        },
        adminRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin);
        },
        paymentRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment);
        },
        saleRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService) && ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase);
        },
        csRole() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
        },
        isCheckdon() {
            return this.$store.state.authentication.user && this.$store.state.authentication.user.username === 'checkdon';
        },
        shippingTypes() {
            return this.configuration && this.configuration.ShippingTypes ? JSON.parse(this.configuration.ShippingTypes) : [];
        },
        customers() {
            if (this.isCheckdon) {
                return this.all_customers;
            }
            let role_type = this.$store.state.authentication.user.roletype;
            let user_id = this.$store.state.authentication.user.userid;
            return _.filter(this.all_customers, function (o) {
                return ((role_type & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((role_type & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment) || ((role_type & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN) || o.SaleID == user_id || o.SaleTransportID == user_id || o.BuyerID == user_id || o.CustomerServiceID == user_id;
            })
        },
        headers() {
            if (this.currentItem && this.currentItem.Details && this.currentItem.Details.length > 0 && this.currentItem.Details[0].OrderType == 3) {
                return [
                    {
                        text: "Mã vận đơn",
                        value: "TransactionCode",
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Cân nặng",
                        value: "TotalWeight",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Giá VCQT",
                        value: "FeeWeight",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Phí VCQT",
                        value: "FeeWeightAmount",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ship nội địa",
                        value: "FeeShip",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Bảo hiểm",
                        value: "GuaranteeAmountVND",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Kiểm đếm",
                        value: "CheckFeeVND",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Đóng gỗ",
                        value: "FragileFeeVND",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Bọt khí",
                        value: "FoamFeeVND",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ship tận nhà",
                        value: "FeeShipVN",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Phát sinh",
                        value: "FeeOther",
                        align: "end",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ghi chú phát sinh",
                        value: "FeeOtherNote",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Ghi chú kho gửi",
                        value: "StoreCNNote",
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tổng tiền",
                        value: "TotalAmount",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Đã thanh toán",
                        value: "TotalPaidAmount",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Cần thanh toán",
                        value: "TotalRemainAmount",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: configs.ORDER_STATUS
                    },
                    {
                        text: "Kho gửi",
                        value: "ChinaStoreID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: []
                    },
                    {
                        text: "Kho nhận",
                        value: "ReceivePlaceID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Enum"],
                        values: []
                    },
                    {
                        text: ""
                    }
                ];
            }
            return [
                {
                    text: "Mã đơn",
                    value: "OrderID",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân/khối",
                    value: "TotalWeight",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalAmount",
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.ORDER_STATUS
                },
                {
                    text: "Kho gửi",
                    value: "ChinaStoreID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: []
                },
                {
                    text: "Kho nhận",
                    value: "ReceivePlaceID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Enum"],
                    values: []
                },
                {
                    text: ""
                }
            ]
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("paymentRequest/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("paymentRequest/setDetail", {
                    data: {
                        ID: 0,
                        Status: this.request_status_enum.nhap,
                        UID: 0,
                        Orders: [],
                        Note: `1.Kế toán:
- Xuất kho thanh toán/ chưa thanh toán/ (hoặc) Yêu cầu thanh toán đặc biệt (nếu có);
- Khách hẹn khi nào thanh toán:
- Lý do xuất kho chưa thanh toán: 
- Phí ship tận nhà thu vào đơn: xxxx
2. Kho:
- Khách tự đến kho/ Khách trả ship/ (hay) Kho trả ship;
- Yêu cầu đặc biệt: Gửi nhà xe quen tên xxx/ Khách ưu tiên nhận hàng khung giờ .../.../ (hoặc) Khách hẹn .../... giờ qua  kho lấy hàng.`
                    }
                })
            }
        },
        saveData(status = null) {
            if (this.isCheckdon) {
                sendErrorNotice('Tài khoản checkdon chỉ có quyền xem yêu cầu giao hàng');
                return;
            }
            if (this.paymentRole && this.currentItem.AccountantID != this.currentUserID) {
                sendErrorNotice('Bạn không có quyền chỉnh sửa yêu cầu giao hàng');
                return;
            }
            if (!this.$refs.entryForm.validate()) {
                return;
            }
            if (!this.adminRole && (this.currentItem.Status == this.request_status_enum.hoan_thanh || this.paymentRole)) {
                sendErrorNotice('Bạn không có quyền chỉnh sửa yêu cầu giao hàng');
                return;
            }
            if (!this.currentItem.Details || this.currentItem.Details.length == 0) {
                sendErrorNotice('Hãy chọn danh sách đơn hàng cho yêu cầu giao');
                return;
            }

            const shippingType = _.find(this.shippingTypes, { 'value': this.currentItem.ShippingType });
            let payload = {
                ...this.currentItem,
                ShippingMethod: shippingType ? shippingType.name : ''
            }

            delete payload.Details
            delete payload.Status
            if (status !== null) {
                payload.Status = status;
            }
            this.$store.dispatch("paymentRequest/setDetail", {
                data: payload,
                id: this.currentItem.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "PaymentRequest");
        },
        addDetailItem() {
            if (this.isCheckdon) return;
            if (!this.$refs.entryForm.validate()) {
                return;
            }
            this.getAvailableOrders();
            this.selectedDetail = [];
            this.dialogItem = true;
        },
        addPackageItem() {
            if (this.isCheckdon) return;
            if (!this.$refs.entryForm.validate()) {
                return;
            }
            this.getAvailablePackages();
            this.selectedDetail = [];
            this.dialogPackageItem = true;
        },
        deleteDetailItem(id) {
            if (this.isCheckdon) return;
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        onSelectCustomer() {
            let customer = _.find(this.customers, { 'ID': this.currentItem.UID });
            this.currentItem.Username = customer ? customer.Username : '';
            this.currentItem.ReceiverPhone = customer ? customer.PhoneNumber : '';
            this.currentItem.ReceiverAddress = customer ? customer.Address : '';
        },
        onSelectStaff() {
            let staff = _.find(this.staffs, { 'ID': this.currentItem.StoreUID });
            this.currentItem.StoreUname = staff ? staff.Username : '';
        },
        onSelectDetail() {
            if (this.selectedDetail.length == 0) {
                sendErrorNotice("Hãy chọn danh sách đơn hàng.");
                return;
            }
            if (_.some(this.selectedDetail, p => !p.TotalWeight)) {
                sendErrorNotice("Hãy chọn danh sách đơn hàng có cân nặng.");
                return;
            }
            let payload = {};
            if (!this.currentId) {
                payload = { ...this.currentItem }
            }
            if (this.dialogItem) {
                payload.Orders = [...this.selectedDetail];
            }
            else if (this.dialogPackageItem) {
                payload.Packages = [...this.selectedDetail];
            }
            this.$store.dispatch("paymentRequest/setDetail", {
                data: payload,
                id: this.currentItem.ID
            }).then((ret) => {
                ret = ret.data ? ret.data : ret;
                if (_.isEmpty(ret)) {
                    sendErrorNotice("Lỗi, không load được dữ liệu.");
                } else if (!this.currentItem.ID) {
                    this.$router.push({
                        name: "PaymentRequestDetail",
                        params: { Pid: ret.ID, title: `Chi tiết yêu cầu giao hàng` },
                    });
                }
            });
            this.selectedDetail = [];
            this.dialogItem = false;
            this.dialogPackageItem = false;
        },
        applyFilterDetail(filterConditions) {
            this.filterConditions = filterConditions;
            this.getAvailableProduct();
        },
        quickFilterDetail(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.getAvailableProduct();
        },
        getAvailableOrders() {
            let order_ids = _.map(this.currentItem.Orders, "OrderID");
            var param = {
                filter: [],
                quickFilter: []
            };
            param.filter.push({
                column: "UID",
                value: this.currentItem.UID,
                condition: "equal",
            });
            if (order_ids.length > 0) {
                param.filter.push({
                    column: "OrderID",
                    value: order_ids,
                    condition: "not_in",
                });
            }
            this.$store.dispatch("paymentRequest/getOrderList", param);
        },
        getAvailablePackages() {
            let package_ids = _.map(this.currentItem.Packages, "ID");
            var param = {
                filter: [],
                quickFilter: []
            };
            param.filter.push({
                column: "UID",
                value: this.currentItem.UID,
                condition: "equal",
            });
            if (package_ids.length > 0) {
                param.filter.push({
                    column: "ID",
                    value: package_ids,
                    condition: "not_in",
                });
            }
            this.$store.dispatch("paymentRequest/getPackageList", param);
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "PhoneNumber", "Address", "SaleID", "SaleTransportID", "BuyerID", "CustomerServiceID"]
            });
        },
        get_status_color(value, enums) {
            const objStatus = enums.find(obj => obj.value === value);
            return objStatus ? objStatus.color : 'black';
        },
        paymentAndExport() {
            if (this.isCheckdon) {
                sendErrorNotice('Tài khoản checkdon chỉ có quyền xem yêu cầu giao hàng');
                return;
            }
            let routeData = this.$router.resolve({
                name: "PayOrderList",
                params: { title: `Thanh toán tiền hàng` },
                query: { 'uid': this.currentItem.UID, 'rid': this.currentItem.ID }
            });
            window.open(routeData.href, "_blank");
        },
        onChangeShippingType() {
            if (this.currentItem.ShippingType == 4 || this.currentItem.ShippingType == 8) {
                this.currentItem.IsFreeShip = 2;
            }
            else { this.currentItem.IsFreeShip = 0; }
        }
    },
    mounted() {
        if (this.isCheckdon && this.modifyId === 'tao-moi') {
            sendErrorNotice('Tài khoản checkdon chỉ có quyền xem yêu cầu giao hàng.');
            this.$router.push({ name: 'PaymentRequest' });
            return;
        }
        this.refreshData();
        this.getCustomerList();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$store.dispatch("commons/getAllUsers");
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllChinaStores");
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            if (this.isCheckdon) return;
            this.$store.dispatch("paymentRequestDetail/removeDetail", id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
    },
};
</script>
<style scoped>
.disabled-row {
    background-color: #dedede !important;
    color: #9e9e9e;
}
</style>